
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { int32_type, list_type, bool_type, record_type, option_type, float64_type, string_type, union_type, class_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { map } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

export class AssignmentNotificationId extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["AssignmentNotificationId"];
    }
}

export function AssignmentNotificationId_$reflection() {
    return union_type("Shared.AssignmentNotification.AssignmentNotificationId", [], AssignmentNotificationId, () => [[["Item", class_type("System.Guid")]]]);
}

export function AssignmentNotificationId__get_unwrap(this$) {
    return this$.fields[0];
}

export const alreadyDecidedValidationMessage = "validation.assignment_notification.already_decided";

export class ActionType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StorageToUser", "UserToStorage", "UserToUser", "UserToStorageRequest", "StorageToUserBulk", "ReturnConsumableToStorage", "ReturnConsumableToStorageRequest"];
    }
}

export function ActionType_$reflection() {
    return union_type("Shared.AssignmentNotification.ActionType", [], ActionType, () => [[], [], [], [], [], [], []]);
}

export function ActionType__get_AsString(this$) {
    switch (this$.tag) {
        case 1:
            return "user_to_storage";
        case 2:
            return "user_to_user";
        case 3:
            return "user_to_storage_request";
        case 4:
            return "storage_to_user_bulk";
        case 5:
            return "return_consumable_to_storage";
        case 6:
            return "return_consumable_to_storage_request";
        default:
            return "storage_to_user";
    }
}

export function ActionType_TryParse_Z721C83C5(value) {
    switch (value) {
        case "storage_to_user":
            return new ActionType(0, []);
        case "user_to_storage":
            return new ActionType(1, []);
        case "user_to_user":
            return new ActionType(2, []);
        case "user_to_storage_request":
            return new ActionType(3, []);
        case "storage_to_user_bulk":
            return new ActionType(4, []);
        case "return_consumable_to_storage":
            return new ActionType(5, []);
        case "return_consumable_to_storage_request":
            return new ActionType(6, []);
        default:
            return undefined;
    }
}

export class NotificationState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Created", "Accepted", "Rejected", "Withdrawn", "DirectAssigned"];
    }
}

export function NotificationState_$reflection() {
    return union_type("Shared.AssignmentNotification.NotificationState", [], NotificationState, () => [[], [], [], [], []]);
}

export function NotificationState__get_AsString(this$) {
    switch (this$.tag) {
        case 1:
            return "accepted";
        case 2:
            return "rejected";
        case 3:
            return "withdrawn";
        case 4:
            return "direct_assigned";
        default:
            return "created";
    }
}

export function NotificationState_TryParse_Z721C83C5(value) {
    switch (value) {
        case "created":
            return new NotificationState(0, []);
        case "accepted":
            return new NotificationState(1, []);
        case "rejected":
            return new NotificationState(2, []);
        case "withdrawn":
            return new NotificationState(3, []);
        case "direct_assigned":
            return new NotificationState(4, []);
        default:
            return undefined;
    }
}

export class StateChangeKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["State", "Paused", "Unpaused"];
    }
}

export function StateChangeKind_$reflection() {
    return union_type("Shared.AssignmentNotification.StateChangeKind", [], StateChangeKind, () => [[["Item", NotificationState_$reflection()]], [], []]);
}

export function StateChangeKind__get_AsString(this$) {
    switch (this$.tag) {
        case 1:
            return "paused";
        case 2:
            return "unpaused";
        default:
            return NotificationState__get_AsString(this$.fields[0]);
    }
}

export function StateChangeKind_TryParse_Z721C83C5(value) {
    switch (value) {
        case "paused":
            return new StateChangeKind(1, []);
        case "unpaused":
            return new StateChangeKind(2, []);
        default:
            return map((Item) => (new StateChangeKind(0, [Item])), NotificationState_TryParse_Z721C83C5(value));
    }
}

export class EntityType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Set", "Consumable"];
    }
}

export function EntityType_$reflection() {
    return union_type("Shared.AssignmentNotification.EntityType", [], EntityType, () => [[], [], [], []]);
}

export function EntityType__get_AsString(this$) {
    switch (this$.tag) {
        case 1:
            return "tool_with_quantity";
        case 2:
            return "set";
        case 3:
            return "consumable";
        default:
            return "tool";
    }
}

export function EntityType_TryParse_Z721C83C5(value) {
    switch (value) {
        case "tool":
            return new EntityType(0, []);
        case "tool_with_quantity":
            return new EntityType(1, []);
        case "set":
            return new EntityType(2, []);
        case "consumable":
            return new EntityType(3, []);
        default:
            return undefined;
    }
}

export class EntityReference extends Record {
    constructor(EntityType, EntityId, Quantity, StorageId, CommissionNumber) {
        super();
        this.EntityType = EntityType;
        this.EntityId = EntityId;
        this.Quantity = Quantity;
        this.StorageId = StorageId;
        this.CommissionNumber = CommissionNumber;
    }
}

export function EntityReference_$reflection() {
    return record_type("Shared.AssignmentNotification.EntityReference", [], EntityReference, () => [["EntityType", EntityType_$reflection()], ["EntityId", string_type], ["Quantity", option_type(float64_type)], ["StorageId", option_type(string_type)], ["CommissionNumber", option_type(string_type)]]);
}

export class ImageRole extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Sender", "Receiver"];
    }
}

export function ImageRole_$reflection() {
    return union_type("Shared.AssignmentNotification.ImageRole", [], ImageRole, () => [[], []]);
}

export function ImageRole__get_AsString(this$) {
    if (this$.tag === 1) {
        return "receiver";
    }
    else {
        return "sender";
    }
}

export function ImageRole_TryParse_Z721C83C5(value) {
    switch (value) {
        case "sender":
            return new ImageRole(0, []);
        case "receiver":
            return new ImageRole(1, []);
        default:
            return undefined;
    }
}

export class NotificationImage extends Record {
    constructor(Id, EntityType, EntityId, Role, ImageUrl, UploadedByUserId, UploadedAt) {
        super();
        this.Id = Id;
        this.EntityType = EntityType;
        this.EntityId = EntityId;
        this.Role = Role;
        this.ImageUrl = ImageUrl;
        this.UploadedByUserId = UploadedByUserId;
        this.UploadedAt = UploadedAt;
    }
}

export function NotificationImage_$reflection() {
    return record_type("Shared.AssignmentNotification.NotificationImage", [], NotificationImage, () => [["Id", class_type("System.Guid")], ["EntityType", EntityType_$reflection()], ["EntityId", string_type], ["Role", ImageRole_$reflection()], ["ImageUrl", string_type], ["UploadedByUserId", string_type], ["UploadedAt", class_type("System.DateTime")]]);
}

export class NotificationStateChange extends Record {
    constructor(Id, Kind, ChangedByUserId, ReceiverComment, SignatureUrl, PausedUntil, ChangedAt) {
        super();
        this.Id = Id;
        this.Kind = Kind;
        this.ChangedByUserId = ChangedByUserId;
        this.ReceiverComment = ReceiverComment;
        this.SignatureUrl = SignatureUrl;
        this.PausedUntil = PausedUntil;
        this.ChangedAt = ChangedAt;
    }
}

export function NotificationStateChange_$reflection() {
    return record_type("Shared.AssignmentNotification.NotificationStateChange", [], NotificationStateChange, () => [["Id", class_type("System.Guid")], ["Kind", StateChangeKind_$reflection()], ["ChangedByUserId", string_type], ["ReceiverComment", option_type(string_type)], ["SignatureUrl", option_type(string_type)], ["PausedUntil", option_type(class_type("System.DateTime"))], ["ChangedAt", class_type("System.DateTime")]]);
}

export class NotificationProcedureLink extends Record {
    constructor(ProcedureId, IsMandatory) {
        super();
        this.ProcedureId = ProcedureId;
        this.IsMandatory = IsMandatory;
    }
}

export function NotificationProcedureLink_$reflection() {
    return record_type("Shared.AssignmentNotification.NotificationProcedureLink", [], NotificationProcedureLink, () => [["ProcedureId", class_type("System.Guid")], ["IsMandatory", bool_type]]);
}

export class AssignmentNotification extends Record {
    constructor(Id, ActionType, SenderId, ReceiverId, StorageId, SenderComment, WithSignature, PlannedReturnDate, CommissionNumber, DispolistId, CurrentState, PausedUntil, LegacyFirestoreId, Entities, StateHistory, Images, Procedures, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.ActionType = ActionType;
        this.SenderId = SenderId;
        this.ReceiverId = ReceiverId;
        this.StorageId = StorageId;
        this.SenderComment = SenderComment;
        this.WithSignature = WithSignature;
        this.PlannedReturnDate = PlannedReturnDate;
        this.CommissionNumber = CommissionNumber;
        this.DispolistId = DispolistId;
        this.CurrentState = CurrentState;
        this.PausedUntil = PausedUntil;
        this.LegacyFirestoreId = LegacyFirestoreId;
        this.Entities = Entities;
        this.StateHistory = StateHistory;
        this.Images = Images;
        this.Procedures = Procedures;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function AssignmentNotification_$reflection() {
    return record_type("Shared.AssignmentNotification.AssignmentNotification", [], AssignmentNotification, () => [["Id", AssignmentNotificationId_$reflection()], ["ActionType", ActionType_$reflection()], ["SenderId", string_type], ["ReceiverId", option_type(string_type)], ["StorageId", option_type(string_type)], ["SenderComment", option_type(string_type)], ["WithSignature", bool_type], ["PlannedReturnDate", option_type(class_type("System.DateTime"))], ["CommissionNumber", option_type(string_type)], ["DispolistId", option_type(string_type)], ["CurrentState", NotificationState_$reflection()], ["PausedUntil", option_type(class_type("System.DateTime"))], ["LegacyFirestoreId", option_type(string_type)], ["Entities", list_type(EntityReference_$reflection())], ["StateHistory", list_type(NotificationStateChange_$reflection())], ["Images", list_type(NotificationImage_$reflection())], ["Procedures", list_type(NotificationProcedureLink_$reflection())], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class DataTransferObject_CreateAssignmentNotificationDto extends Record {
    constructor(ExplicitId, GroupId, ActionType, SenderId, ReceiverId, StorageId, SenderComment, WithSignature, PlannedReturnDate, CommissionNumber, DispolistId, LegacyFirestoreId, Entities, Procedures) {
        super();
        this.ExplicitId = ExplicitId;
        this.GroupId = GroupId;
        this.ActionType = ActionType;
        this.SenderId = SenderId;
        this.ReceiverId = ReceiverId;
        this.StorageId = StorageId;
        this.SenderComment = SenderComment;
        this.WithSignature = WithSignature;
        this.PlannedReturnDate = PlannedReturnDate;
        this.CommissionNumber = CommissionNumber;
        this.DispolistId = DispolistId;
        this.LegacyFirestoreId = LegacyFirestoreId;
        this.Entities = Entities;
        this.Procedures = Procedures;
    }
}

export function DataTransferObject_CreateAssignmentNotificationDto_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.CreateAssignmentNotificationDto", [], DataTransferObject_CreateAssignmentNotificationDto, () => [["ExplicitId", option_type(class_type("System.Guid"))], ["GroupId", option_type(class_type("System.Guid"))], ["ActionType", ActionType_$reflection()], ["SenderId", string_type], ["ReceiverId", option_type(string_type)], ["StorageId", option_type(string_type)], ["SenderComment", option_type(string_type)], ["WithSignature", bool_type], ["PlannedReturnDate", option_type(class_type("System.DateTime"))], ["CommissionNumber", option_type(string_type)], ["DispolistId", option_type(string_type)], ["LegacyFirestoreId", option_type(string_type)], ["Entities", list_type(EntityReference_$reflection())], ["Procedures", list_type(NotificationProcedureLink_$reflection())]]);
}

export class DataTransferObject_AcceptAssignmentNotificationDto extends Record {
    constructor(ReceiverComment, SignatureUrl) {
        super();
        this.ReceiverComment = ReceiverComment;
        this.SignatureUrl = SignatureUrl;
    }
}

export function DataTransferObject_AcceptAssignmentNotificationDto_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.AcceptAssignmentNotificationDto", [], DataTransferObject_AcceptAssignmentNotificationDto, () => [["ReceiverComment", option_type(string_type)], ["SignatureUrl", option_type(string_type)]]);
}

export class DataTransferObject_RejectAssignmentNotificationDto extends Record {
    constructor(ReceiverComment) {
        super();
        this.ReceiverComment = ReceiverComment;
    }
}

export function DataTransferObject_RejectAssignmentNotificationDto_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.RejectAssignmentNotificationDto", [], DataTransferObject_RejectAssignmentNotificationDto, () => [["ReceiverComment", option_type(string_type)]]);
}

export class DataTransferObject_WithdrawAssignmentNotificationDto extends Record {
    constructor(Comment$) {
        super();
        this.Comment = Comment$;
    }
}

export function DataTransferObject_WithdrawAssignmentNotificationDto_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.WithdrawAssignmentNotificationDto", [], DataTransferObject_WithdrawAssignmentNotificationDto, () => [["Comment", option_type(string_type)]]);
}

export class DataTransferObject_PauseAssignmentNotificationDto extends Record {
    constructor(PausedUntil) {
        super();
        this.PausedUntil = PausedUntil;
    }
}

export function DataTransferObject_PauseAssignmentNotificationDto_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.PauseAssignmentNotificationDto", [], DataTransferObject_PauseAssignmentNotificationDto, () => [["PausedUntil", class_type("System.DateTime")]]);
}

export class DataTransferObject_AddNotificationImageDto extends Record {
    constructor(EntityType, EntityId, Role, ImageUrl) {
        super();
        this.EntityType = EntityType;
        this.EntityId = EntityId;
        this.Role = Role;
        this.ImageUrl = ImageUrl;
    }
}

export function DataTransferObject_AddNotificationImageDto_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.AddNotificationImageDto", [], DataTransferObject_AddNotificationImageDto, () => [["EntityType", EntityType_$reflection()], ["EntityId", string_type], ["Role", ImageRole_$reflection()], ["ImageUrl", string_type]]);
}

export class DataTransferObject_CreateBulkAssignmentNotificationToolItem extends Record {
    constructor(Id, ToolId, SenderImageUrls) {
        super();
        this.Id = Id;
        this.ToolId = ToolId;
        this.SenderImageUrls = SenderImageUrls;
    }
}

export function DataTransferObject_CreateBulkAssignmentNotificationToolItem_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.CreateBulkAssignmentNotificationToolItem", [], DataTransferObject_CreateBulkAssignmentNotificationToolItem, () => [["Id", string_type], ["ToolId", string_type], ["SenderImageUrls", list_type(string_type)]]);
}

export class DataTransferObject_CreateBulkAssignmentNotificationSetItem extends Record {
    constructor(Id, SetId, SenderImageUrls) {
        super();
        this.Id = Id;
        this.SetId = SetId;
        this.SenderImageUrls = SenderImageUrls;
    }
}

export function DataTransferObject_CreateBulkAssignmentNotificationSetItem_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.CreateBulkAssignmentNotificationSetItem", [], DataTransferObject_CreateBulkAssignmentNotificationSetItem, () => [["Id", string_type], ["SetId", string_type], ["SenderImageUrls", list_type(string_type)]]);
}

export class DataTransferObject_CreateBulkAssignmentNotificationToolWithQuantityItem extends Record {
    constructor(Id, ToolId, Quantity, StorageId, SenderImageUrls) {
        super();
        this.Id = Id;
        this.ToolId = ToolId;
        this.Quantity = (Quantity | 0);
        this.StorageId = StorageId;
        this.SenderImageUrls = SenderImageUrls;
    }
}

export function DataTransferObject_CreateBulkAssignmentNotificationToolWithQuantityItem_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.CreateBulkAssignmentNotificationToolWithQuantityItem", [], DataTransferObject_CreateBulkAssignmentNotificationToolWithQuantityItem, () => [["Id", string_type], ["ToolId", string_type], ["Quantity", int32_type], ["StorageId", string_type], ["SenderImageUrls", list_type(string_type)]]);
}

export class DataTransferObject_CreateBulkAssignmentNotificationConsumableItem extends Record {
    constructor(Id, ConsumableId, Quantity, StorageId, CommissionNumber, SenderImageUrls) {
        super();
        this.Id = Id;
        this.ConsumableId = ConsumableId;
        this.Quantity = Quantity;
        this.StorageId = StorageId;
        this.CommissionNumber = CommissionNumber;
        this.SenderImageUrls = SenderImageUrls;
    }
}

export function DataTransferObject_CreateBulkAssignmentNotificationConsumableItem_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.CreateBulkAssignmentNotificationConsumableItem", [], DataTransferObject_CreateBulkAssignmentNotificationConsumableItem, () => [["Id", string_type], ["ConsumableId", string_type], ["Quantity", float64_type], ["StorageId", string_type], ["CommissionNumber", string_type], ["SenderImageUrls", list_type(string_type)]]);
}

export class DataTransferObject_CreateBulkAssignmentNotificationDto extends Record {
    constructor(ReceiverId, Comment$, WithSignature, PlannedReturnDate, Tools, Sets, ToolsWithQuantity, Consumables) {
        super();
        this.ReceiverId = ReceiverId;
        this.Comment = Comment$;
        this.WithSignature = WithSignature;
        this.PlannedReturnDate = PlannedReturnDate;
        this.Tools = Tools;
        this.Sets = Sets;
        this.ToolsWithQuantity = ToolsWithQuantity;
        this.Consumables = Consumables;
    }
}

export function DataTransferObject_CreateBulkAssignmentNotificationDto_$reflection() {
    return record_type("Shared.AssignmentNotification.DataTransferObject.CreateBulkAssignmentNotificationDto", [], DataTransferObject_CreateBulkAssignmentNotificationDto, () => [["ReceiverId", string_type], ["Comment", string_type], ["WithSignature", bool_type], ["PlannedReturnDate", option_type(string_type)], ["Tools", list_type(DataTransferObject_CreateBulkAssignmentNotificationToolItem_$reflection())], ["Sets", list_type(DataTransferObject_CreateBulkAssignmentNotificationSetItem_$reflection())], ["ToolsWithQuantity", list_type(DataTransferObject_CreateBulkAssignmentNotificationToolWithQuantityItem_$reflection())], ["Consumables", list_type(DataTransferObject_CreateBulkAssignmentNotificationConsumableItem_$reflection())]]);
}

